import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/OpnPledgePage.head';
import { OpnPledgePage } from '@pages/OpnPledgePage';

export const Route = createFileRoute('/opn-pledge')({
  component: OpnPledgePage,
  head: () => head,
});
